import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/brand/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-deep-ink px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl bg-warm-ivory p-8 lg:p-10">
        <Logo />
        <div className="mt-8 flex items-center gap-2 text-champagne-gold">
          <Lock className="h-4 w-4" /><span className="text-sm uppercase tracking-editorial">Admin portal</span>
        </div>
        <h1 className="mt-2 font-serif text-3xl text-deep-ink">Sign in</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="mb-1.5 block text-sm text-deep-ink/70">Email</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-sand" required />
          </div>
          <div>
            <Label className="mb-1.5 block text-sm text-deep-ink/70">Password</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-sand" required />
          </div>
          {error && <p className="text-sm text-terracotta" data-testid="admin-login-error">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full rounded-full bg-deep-ink py-6 text-warm-ivory hover:bg-champagne-gold hover:text-deep-ink">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
